// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"538":"recorder","983":"profiler"}[chunkId] || chunkId) + "." + {"125":"6057c82236ef0fe2","185":"a51f099b134200f5","538":"fe0a9bd24001c083","983":"7409efa7dc3620ee"}[chunkId] + ".js";
};